export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_INBOX = 'inbox-received-transfers';
export const EXPERIMENT_SEND_FEEDBACK = 'send-feedback';
export const EXPERIMENT_TRANSFER_OPTIONS_ICON = 'transfer-options-icon';
export const EXPERIMENT_SPLASHPAGE_COPY = 'splashpage-copy';
export const EXPERIMENT_SPLASHPAGE_FAKE_DOOR = 'splashpage-fake-door';
export const EXPERIMENT_FREE_ACCOUNT = 'free-account';
export const EXPERIMENT_CANCELLATION_COPY = 'cancellation-copy';
export const EXPERIMENT_RECEIVING_PAGE = 'receiving-page';
export const EXPERIMENT_UPSELL_PROGRESS_PANEL = 'upsell-progress-panel';
export const EXPERIMENT_TRANSFER_TOOLTIP = 'transfer-tooltip';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';
export const FF_REFACTOR_TRANSFER_MODULE = 'refactor-transfer-module';
